import { Language } from 'interface/settings/settings.interface';

export const getSelectedlanguage = (languages: Language[], selectedLanguageId?: string) => {
  const selectedLang = languages.find((lang) => lang.id === selectedLanguageId);
  const defaultLang = languages.find((lang) => lang.isDefault);
  if (selectedLang) {
    return {
      id: selectedLang.id,
      text: `${selectedLang.name.toUpperCase()}${selectedLang.isDefault ? ' (default)' : ''}`,
    };
  } else if (defaultLang) {
    return { id: defaultLang.id, text: `${defaultLang.name.toUpperCase()} (default)` };
  } else if (languages.length > 0) {
    return { id: languages[0].id, text: `${languages[0].name.toUpperCase()} (default)` };
  } else {
    return { id: 'en', text: 'ENGLISH (default)' };
  }
};
